import React from 'react';

export default function TableBooleanAll(props) {
    const { value = false, text = null } = props;

    const iconClass =  value ? ('fa fa-' + 'check') : ('fa fa-' + 'times');
    const valueText = `${'\u00A0'}${text}`;
    
    return (
        <span>
            {iconClass && 
                <>
                    <i className={iconClass}></i>{valueText}
                </>
            }
        </span>
    );
}
